<style scoped>
.img {
  height: 30px;
}
.ellipsis-1 {
  max-width: 180px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: break-word;
  word-break: break-all;
}
.w150 {
  width: 150px;
}
</style>
<template>
  <div class="pageCentent">
    <a-form-model
      size="small"
      layout="inline"
      @keyup.native.enter="handleSearch()"
    >
      <a-form-model-item label="用户名">
        <a-input
          placeholder="请输入用户名"
          v-model="ajaxparams['user_name_no']"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button icon="search" @click="handleSearch()" type="primary">
          搜索</a-button
        >
      </a-form-model-item>
    </a-form-model>
    <div>
      <MyTable
        class="mt10"
        :isSelection="false"
        :apiUrl="apiUrl"
        :params="ajaxparams"
        ref="myTable"
        :columns="columns"
      >
        <a-space slot="content" slot-scope="item, row">
          <div v-for="(item, index) in row.content.split(';')" :key="index">
            {{ item }}
          </div>
        </a-space>
      </MyTable>
    </div>
    <a-modal :footer="null" v-model="dialogVisible" title="查看">
      <img style="width: 100%" :src="dialogImg" alt />
    </a-modal>
  </div>
</template>
<script>
import MyTable from "@/components/myTable.vue";
import { Questionnaire_index } from "@/api/manager";

export default {
  components: { MyTable },
  data() {
    return {
      apiUrl: Questionnaire_index,
      ajaxparams: {
        page: 1,
        limit: 10,
      },
      dialogImg: "",
      dialogVisible: false,
      columns: [
        {
          title: "用户名",
          dataIndex: "user.name",
          key: "user.name",
          width: 150,
        },
        {
          title: "商品名称",
          dataIndex: "goods_name",
          key: "goods_name",
          width: 150,
        },
        {
          title: "问卷内容",
          dataIndex: "content",
          key: "content",
          width: 300,
          scopedSlots: { customRender: "content" },
        },
        {
          title: "创建时间",
          dataIndex: "create_at",
          key: "create_at",
          width: 180,
        },
      ],
    };
  },
  methods: {
    handleSearch() {
      if (
        !this.ajaxparams.user_name_no ||
        this.ajaxparams.user_name_no.trim() === ""
      ) {
        delete this.ajaxparams.user_name_no;
      }
      this.$refs.myTable.search();
    },
    showDialog(src) {
      this.dialogImg = src;
      this.dialogVisible = true;
    },
  },
};
</script>
